module.exports = __webpack_public_path__ + "img/WL6.c23894e0.svg";